import { render, staticRenderFns } from "./NbaSportsBook.vue?vue&type=template&id=0d135cf0&scoped=true"
import script from "./NbaSportsBook.vue?vue&type=script&lang=js"
export * from "./NbaSportsBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d135cf0",
  null
  
)

export default component.exports